<template>
  <section>

    <b-container fluid>

          <span v-for="(object,index) in details.items" :key="index">
            <nl2br tag="span" :text="object.value" v-if="object.type == `text`"></nl2br>
            <section-form  v-if="object.type == `section`" :level="1" :templateId="templateId" :item="object"></section-form>               
          </span>

    </b-container>

  </section>
</template>
<script>
import SectionForm from "./SectionForm";
export default {
  components: {
    SectionForm
  },
  props: ["item","templateId"],
  data() {
    return {
      details: this.item,
      user: this.$store.getters["auth/user"]
    };
  },
  methods: {},
  mounted() {  
  }
};
</script>
<style>
</style>